import * as React from 'react';
import { merge } from 'lodash';

import { Pressable, WBText, TextProps } from '@/core';
import { getModifiedStyles } from '@/helpers';
import linkStyles from './style';

export interface LinkProps {
	/**
	 * Determines disabled state of link. Disables any user interaction when true.
	 */
	isDisabled?: boolean;
	/**
	 * Callback called when the user presses link.
	 */
	onPress?: () => void;
	/**
	 * An object to style the text of the component.
	 */
	style?: TextProps['style'];
}

export const WBLink: React.FC<LinkProps> = ({ children, isDisabled, onPress, style }) => {
	const touchableProps = { onPress, disabled: isDisabled };
	const styles = getModifiedStyles(linkStyles, { isDisabled }, 'default', true);

	return (
		<Pressable {...touchableProps} activeOpacity={0.6}>
			<WBText style={merge({}, styles.content, style)}>{children}</WBText>
		</Pressable>
	);
};
